module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', {
    on: {
      "dblclick": _vm.bdlClick
    }
  }, [(_vm.isOpen) ? _c('i', {
    staticClass: "fa fa-folder-open"
  }) : _c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), (_vm.isOpen) ? _c('ul', _vm._l((_vm.content), function(file) {
    return _c('File', {
      key: file.basename,
      attrs: {
        "content": file
      },
      on: {
        "attach-file": _vm.attachFile
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d710be2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/FileUploader/Folder.vue
// module id = 894
// module chunks = 0